<!--
  A window with one panel down its left side, drawn in outline like the
  heroicons outline set. The sidebar toggle uses it, so it no longer shares
  the three-column icon that Column settings uses.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-slot="icon"
    data-icon="panel-left"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M9 4v16" />
  </svg>
</template>
